/**
 * Calculator number-formatting utility.
 *
 * Lives in the container's clientlib because it's the calculator
 * engine's shared formatter — but it's exported as a pure function so
 * the input and slider sub-component helpers can use it without
 * pulling in the controller class. Import path from the sub-components:
 *   ../../../container/clientlibs/site/js/format.js
 *
 * Format keys map to the dropdown values authored on each input /
 * slider / display dialog. Keep the cases in sync with
 * `calculator/input/_cq_dialog.xml` (and friends) when adding new
 * formats.
 */

export function formatNumber(n, formatKey, locale) {
    if (!Number.isFinite(n)) return '0';
    switch (formatKey) {
    case 'decimal1':
        return n.toLocaleString(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    case 'decimal1Auto':
        return n.toLocaleString(locale, { minimumFractionDigits: 0, maximumFractionDigits: 1 });
    case 'decimal2':
        return n.toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    case 'decimal2Auto':
        return n.toLocaleString(locale, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    case 'abbrevK': {
        if (Math.abs(n) >= 1000) {
            return `${(n / 1000).toLocaleString(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 })}K`;
        }
        return Math.round(n).toLocaleString(locale);
    }
    case 'abbrevAuto': {
        const abs = Math.abs(n);
        if (abs >= 1e9) return `${(n / 1e9).toLocaleString(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 })}B`;
        if (abs >= 1e6) return `${(n / 1e6).toLocaleString(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 })}M`;
        if (abs >= 1e3) return `${(n / 1e3).toLocaleString(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 })}K`;
        return Math.round(n).toLocaleString(locale);
    }
    case 'plain':
        return String(Math.round(n));
    case 'integer':
    default:
        return Math.round(n).toLocaleString(locale);
    }
}
